import { api } from '../api';

export interface Room {
  id: string;
  name: string;
  description?: string;
  virtualKey?: boolean;
  tenantId: string;
  createdAt: string;
  updatedAt: string;
  is_enabled_virtual_key?: boolean;
}

export const roomService = {
  list: async () => {
    const response = await api.get<Room[]>('/rooms');
    return response;
  },

  getById: async (id: string) => {
    const response = await api.get<Room>(`/rooms/${id}`);
    return response;
  },

  create: async (data: Omit<Room, 'id' | 'createdAt' | 'updatedAt'>) => {
    data.is_enabled_virtual_key = data.virtualKey;
    const response = await api.post<Room>('/rooms', data);
    return response;
  },

  update: async (id: string, data: Partial<Omit<Room, 'id' | 'createdAt' | 'updatedAt'>>) => {
    const response = await api.put<Room>(`/rooms/${id}`, data);
    return response;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/rooms/${id}`);
    return response;
  },
};